import { EMAIL_MATCH_REGEXP } from 'constants/regExp';

import * as Yup from 'yup';

export const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .trim()
        .matches(EMAIL_MATCH_REGEXP, 'validation.email.invalid')
        .required('validation.email.required'),
});
